import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import 'tailwindcss/tailwind.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import { Locale } from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import '@/assets/scss/index.scss'
import mixin from '@/helpers/mixin.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)

Vue.mixin(mixin)

// eslint-disable-next-line no-unused-vars
import * as http from './helpers/http';
Vue.prototype.$http = axios

const lang = new URLSearchParams(window.location.search).get('lang') || localStorage.getItem('lang') || 'cn';
console.log(lang);
lang === 'en' ? Locale.use('en-US', enUS) : Locale.use('zh-CN', zhCN);
localStorage.setItem('lang', lang);

import {i18n} from './helpers/lang';

Vue.prototype.$i18 = i18n;

import VueI18nFilter from 'vue-i18n-filter'

Vue.use(VueI18nFilter);

Vue.config.productionTip = false

Vue.use(Vant)
new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
